import { motion } from 'framer-motion';
import { ArrowRight, Sparkles } from 'lucide-react';
import Balancer from 'react-wrap-balancer';

import { APP_URL } from '@marketing/data/nav';
import { LumeMark } from '@marketing/illustrations/LumeMark';
import { useMagnetic } from '@marketing/motion/useMagnetic';
import { heroChild, heroMark, heroParent } from '@marketing/motion/variants';

// ============================================================
// Hero — primeira seção. Cinemática mas low-stim.
// ============================================================

export function Hero() {
  const primaryRef = useMagnetic<HTMLAnchorElement>({ strength: 12 });

  return (
    <section
      id="top"
      className="lume-hero"
      aria-labelledby="hero-title"
    >
      <div aria-hidden="true" className="lume-hero__mesh" />

      <div className="lume-container">
        <motion.div
          className="lume-hero__grid"
          initial="hidden"
          animate="visible"
          variants={heroParent}
        >
          <div className="lume-stack lume-stack-lg">
            <motion.p variants={heroChild} className="lume-eyebrow">
              <Sparkles size={14} aria-hidden="true" style={{ display: 'inline', marginRight: 6 }} />
              Programa TEACare
            </motion.p>

            <motion.h1 variants={heroChild} id="hero-title" className="lume-h1 lume-text-balance">
              <Balancer>
                Acompanhamento contínuo do TEA, do dispositivo do paciente ao prontuário do médico.
              </Balancer>
            </motion.h1>

            <motion.p variants={heroChild} className="lume-body-lg lume-text-pretty">
              <Balancer>
                O Programa TEACare desenvolveu o <strong>Lume</strong> para reduzir o deslocamento
                físico do autista a hospitais — transformando o uso natural do dispositivo em
                prontuário vivo, com IA como instrumento clínico, nunca diagnosticadora.
              </Balancer>
            </motion.p>

            <motion.div variants={heroChild} className="lume-row" style={{ marginTop: '0.75rem' }}>
              <a
                ref={primaryRef}
                href={APP_URL}
                className="lume-btn lume-btn--primary"
                aria-label="Acessar o aplicativo Lume"
              >
                Acessar o aplicativo
                <ArrowRight size={18} aria-hidden="true" />
              </a>
              <a href="#parceria" className="lume-btn lume-btn--secondary">
                Falar com a equipe
              </a>
              <a href="#showcase" className="lume-btn lume-btn--ghost">
                Ver demonstração ↓
              </a>
            </motion.div>
          </div>

          <motion.div
            variants={heroMark}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 'clamp(1rem, 4vw, 3rem)',
            }}
          >
            <LumeMark size={220} animated title="Lume" />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
